import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ClientsPage = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const columns = ['Client ID', 'Name', 'Email', 'Phone', 'Created At'];

  useEffect(() => {
    const fetchClients = async () => {

    //################################################
    // Grab the token you stored on login
    const token = localStorage.getItem('employeeToken');
    console.log('📥 [ClientsPage] Using token for fetch:', token);

    if (!token) {
      console.warn("🚫 [ClientsPage] No employee token found — redirecting to login");
      window.location.href = "/employee-login"; // or your employee login route
      return;
    }
    //################################################



      try {
        const response = await axios.get(`${apiBaseURL}/api/clients`);
        setClients(response.data);
      } catch (err) {
        setError('Failed to fetch clients.');
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [apiBaseURL]);

  if (loading) return <div>Loading clients...</div>;
  if (error) return <div>{error}</div>;

  const data = clients.map(client => ({
    client_id: client.client_id,
    name: client.name ?? '—',
    email: client.email ?? '—',
    phone: client.phone ?? '—',
    created_at: client.created_at ? new Date(client.created_at).toLocaleString() : '—',
  }));

  // Inline Table Component
  const Table = ({ columns, data }) => {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
          <thead>
            <tr className="bg-gray-200">
              {columns.map((col, index) => (
                <th key={index} className="px-4 py-2 text-left">{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-4 py-2 text-center text-gray-500">No data available</td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <tr key={rowIndex} className="border-b">
                  {columns.map((col, colIndex) => (
                    <td key={colIndex} className="px-4 py-2 whitespace-nowrap">
                      {row[col.toLowerCase().replace(/ /g, '_')]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="flex-1 p-6 bg-gray-100 ml-64">
      <h2 className="text-2xl font-semibold mb-4">Clients</h2>
      <Table columns={columns} data={data} />
    </div>
  );
};

export default ClientsPage;
